import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { doc, setDoc, onSnapshot, updateDoc, deleteDoc, collection } from 'firebase/firestore';
import {
    Plus,
    CheckCircle,
    BrainCircuit,
    Trash2,
    Save,
    FileCode,
    Lock,
    ShieldCheck
} from 'lucide-react';

// System default combined instruction — TEKNIK AI8SAAT master prompt
// This is auto-provisioned to new client accounts
export const SYSTEM_DEFAULT_COMBINED_INSTRUCTION = `

## MASTER PROMPT: AI TIKTOK SHOP AFFILIATE CREATIVE DIRECTOR

**PERANAN GPT:**
Kau ialah **AI TikTok Shop Affiliate Creative Director, Performance Copywriter & Video Ads Scriptwriter**. Tugas kau ialah menukar **gambar + detail produk** menjadi **visual prompt & video prompt yang fokus SALES**.

**PROSES KERJA:**

1. Berikan ringkasan kelebihan dan problem tersebut daripada segala data yang dapat hasil dari details gambar dan carian data terkini di marketplace online.
2. Hasilkan **3 SET KANDUNGAN** unik (Set 1, Set 2, Set 3) berbeza angle, berdasarkan input di bawah.

**INPUT YANG AKAN DIBERI:**

1. Gambar Produk
2. Nama produk
3. Jenis produk
4. Target audience
5. Masalah utama customer
6. USP / kelebihan produk
7. Harga / promo (jika ada)
8. Tone brand (santai / yakin / mak-mak / hard sell)

**ARAHAN KANDUNGAN (WAJIB IKUT):**

Berdasarkan gambar dan detail produk yang diberi, hasilkan 3 SET KANDUNGAN.

Setiap SET MESTI disusun dalam urutan berikut:
1) promptImage (Gemini) dalam bahasa inggeris.
2) promptVideo (Veo 3.1) dalam bahasa inggeris.
3) captionTiktok + 5 Hashtag dalam bahasa melayu malaysia.


**1) promptImage**

* Model wanita Melayu bertudung Malaysia muda (sekitar 28 tahun) (Nampak seperti wanita tempatan Malaysia. Friendly, trustworthy, sesuai sebagai TikTok Shop affiliate. Bukan selebriti, bukan model over-glam. Realistic, lifestyle)
* Bertudung, pakaian sopan dan sesuai dengan produk (Gaya tudung dan pakaian MESTI sesuai dengan:
  1) Background persekitaran (contoh rumah, dapur, outdoor dan sebagainya)
  2) Jenis dan cara penggunaan produk yang dipromosikan)
* Model hanya pegang produk menghadap kamera (review style)
* Seolah-olah sedang bercakap promote produk depan kamera
* TIDAK perlu demo produk
* TIDAK perlu tunjuk cara guna
* Background (persekitaran pula perlu sesuai dengan produk yang di promote), outfit, ekspresi dan sudut copywriting unik.
* Add bold Bahasa Melayu (Malaysia) text overlay\\"#########\\" in a natural, TikTok-style font.
   - Large, eye-catching Bahasa Melayu (Malaysia).
   - White or black stroke/outline around text for contrast
   - IMPORTANT: Do NOT modify, change, or alter the product in any way. The product must retain all its original details, design, colors, labels, and packaging exactly as shown in the reference image.

* (#########) ialah ayat hook yang menonjolkan masalah utama target audience dan memberi rasa ingin tahu untuk terus menonton.
* Saiz: TikTok vertical 9:16
* Hook Text (#########):** Set 1 (Masalah - ayat hook yang menonjolkan masalah utama target audience dan memberi rasa ingin tahu untuk terus menonton.
), Set 2 (Hasil/Manfaat - fokus pada hasil, perubahan, atau manfaat paling kuat produk ini), Set 3 (Stop Scroll -  ayat hook yang buat audience berhenti scroll dan rasa "kena tengok sampai habis".).


**2) promptVideo**

* **Performance Instruction:** 
* Saiz: 9:16, Durasi: 8 saat tepat.
* **Struktur Dialog:**
* 0–2s (Hook): [Ayat hook]
* 2–6s (Value): [Ayat explain]
* 6–8s (CTA): [Ayat suruh beli] , jangan sebut beg kuning atau link atau platform selain tiktok. ajak "checkout" lagi bagus untuk CTA.


## ⚠️ PANTANG LARANG

* Jangan lebih 8 saat
* Jangan ayat berbunga
* Jangan CTA lembut
* Jangan dialog generic
* Jangan ulang ayat sama antara video
* Jangan guna ayat seksual seperti "pegang di dada dan sebagainya"


### 🔹 STRUKTUR PROMPT VIDEO (WAJIB IKUT)

promptVideo :

Visual description:
[Gerakan kamera, aksi model, ekspresi muka]
She/he smiles and says in Bahasa Melayu (Malaysia) while showing the product closer to the camera.

Spoken dialog (exact script):
0–2s (Hook):
[Ayat hook]

2–6s (Value / Problem–Solution):
[Ayat explain & convince]

6–8s (CTA):
[Ayat suruh beli/ order / checkout]

Tone:
[santai / yakin / hard sell / mak-mak]

Fast-paced, high-energy voice delivery. Confident TikTok-style selling tone. Speak clearly but quickly. No pauses, no dramatic silence, no slow emphasis. All lines must be spoken fully within 8 seconds. Do not skip or cut any words.

The text at the top is a permanent burned-in caption that must always remain fully visible and unchanged from the first frame to the last. Do not fade, crop, or remove the text.

NO subtitles or new add text overlays, NO on-screen dialogue text, no mobile/tiktok interface overlay, NO captions of any kind, All dialogue is AUDIO ONLY, reduce contrast, natural skintone, soft highlights, no oversharpen, low contrast, soft colors, natural tone, film look, soft light


**3) captionTiktok**

* Ayat lisan/pasar, gaya racun, fokus jualan. Tidak panjang.
* Wajib 5 hashtag (Mesti ada #racuntiktok #fyp).
* Bahasa Melayu santai (boleh campur English jika sesuai)


**⚠️ PANTANG LARANG:**

* Video 8 saat sahaja.
* Gaya 'racun' untuk buat orang nak cuba & beli. Gunakan bahasa pasar melayu malaysia. jangan baku sangat macam iklan pula.
* Tiada ayat berbunga/baku. ayat jenis content creator tengah review produk.
* Jangan ulang dialog yang sama atau angle yang sama.
* Tiada ayat seksual.


**FORMAT OUTPUT (JSON SAHAJA):**
Balut keseluruhan output ke dalam format JSON berikut. Jangan tambah sebarang teks sebelum atau selepas JSON.

\`\`\`json
{
  "analisis_produk": "Ringkasan kelebihan dan masalah",
  "kandungan": [
    {
      "promptImage": "...",
      "promptVideo": "...",
      "captionTiktok": "..."
    },
    {
      "promptImage": "...",
      "promptVideo": "...",
      "captionTiktok": "..."
    },
    {
      "promptImage": "...",
      "promptVideo": "...",
      "captionTiktok": "..."
    }
  ]
}
\`\`\`
`;

const AIInstructionsView = ({ onNavigate, isAdmin = false, systemDefaultLogicName = 'TEKNIK AI8SAAT', systemDefaultLogicId = '', adminUid = '', selectedSpaceId = 'default', spaces = [] }) => {
    const [personas, setPersonas] = useState([]);
    const [activePersonaId, setActivePersonaId] = useState(null);
    const [localPersona, setLocalPersona] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [showSaveNotification, setShowSaveNotification] = useState(false);


    const [hasProvisionedDefault, setHasProvisionedDefault] = useState(false);

    // Load personas — from shared system_spaces for system spaces, user's own for custom
    useEffect(() => {
        if (!auth.currentUser) return;

        // Reset state when space changes
        setActivePersonaId(null);
        setLocalPersona(null);

        const currentSpace = spaces.find(s => s.id === selectedSpaceId);
        const isSystemSpace = currentSpace?.isSystem;

        const personasPath = isSystemSpace
            ? `system_spaces/ai8saat/personas`
            : `users/${auth.currentUser.uid}/personas`;

        console.log('[AIInstructions] Loading personas from:', personasPath);

        const personasRef = collection(db, ...personasPath.split('/'));
        const unsubscribe = onSnapshot(personasRef, (snapshot) => {
            const items = snapshot.docs.map(d => ({ id: d.id, _isSystem: isSystemSpace || false, ...d.data() }));
            setPersonas(items);
            if (items.length > 0) {
                setActivePersonaId(items[0].id);
            } else {
                setActivePersonaId(null);
                setLocalPersona(null);
            }
        });

        return () => unsubscribe();
    }, [auth.currentUser, selectedSpaceId, spaces]);


    // All personas come from user's own collection — system ones are marked _isSystem
    const allPersonas = personas;

    const activePersona = allPersonas.find(p => p.id === activePersonaId);

    // Sync activePersona to localPersona when activePersonaId changes
    useEffect(() => {
        if (activePersona && (!localPersona || localPersona.id !== activePersona.id)) {
            setLocalPersona(JSON.parse(JSON.stringify(activePersona)));
        } else if (!activePersona) {
            setLocalPersona(null);
        }
    }, [activePersona, activePersonaId]);

    const handleLocalUpdate = (updates) => {
        if (localPersona?._isSystem && !isAdmin) return; // Block editing system persona for clients
        setLocalPersona(prev => ({ ...prev, ...updates }));
    };

    const handleSaveChanges = async () => {
        if (!auth.currentUser || !localPersona) return;
        if (localPersona._isSystem && !isAdmin) return; // Can't save system persona as client

        setIsSaving(true);

        // Determine save path: system personas go to system_spaces, custom go to user's collection
        const currentSpace = spaces.find(s => s.id === selectedSpaceId);
        const isSystemSpace = currentSpace?.isSystem;

        const personaRef = isSystemSpace
            ? doc(db, 'system_spaces', selectedSpaceId === 'default' ? 'ai8saat' : selectedSpaceId, 'personas', localPersona.id)
            : doc(db, 'users', auth.currentUser.uid, 'personas', localPersona.id);

        try {
            const dataToSave = { ...localPersona };
            delete dataToSave.id;
            delete dataToSave._isSystem; // Don't persist; it's derived from space type

            await updateDoc(personaRef, dataToSave);
            setShowSaveNotification(true);
            setTimeout(() => setShowSaveNotification(false), 3000);
            console.log('[AIInstructions] Saved persona to:', personaRef.path);
        } catch (err) {
            console.error('Failed to update persona:', err);
        } finally {
            setIsSaving(false);
        }
    };

    const handleDeletePersona = async () => {
        if (!auth.currentUser || !activePersonaId) return;
        if (!isAdmin) return; // Only admin can delete
        if (!window.confirm("Are you sure you want to delete this logic option? This action cannot be undone.")) return;

        try {
            const currentSpace = spaces.find(s => s.id === selectedSpaceId);
            const isSystemSpace = currentSpace?.isSystem;
            const personaRef = isSystemSpace
                ? doc(db, 'system_spaces', 'ai8saat', 'personas', activePersonaId)
                : doc(db, 'users', auth.currentUser.uid, 'personas', activePersonaId);
            await deleteDoc(personaRef);
            const remaining = personas.filter(p => p.id !== activePersonaId);
            if (remaining.length > 0) {
                setActivePersonaId(remaining[0].id);
            } else {
                setActivePersonaId(null);
            }
        } catch (err) {
            console.error("Failed to delete persona:", err);
        }
    };

    const handleCreatePersona = async () => {
        if (!auth.currentUser) return;
        if (!isAdmin) return; // Only admin can create

        const newPersona = {
            name: 'New Logic Option',
            description: 'Logic untuk generate prompt automatik',
            sets: [
                {
                    id: 'set1', targetSet: 'set1', label: 'Set 1 (Santai)',
                    instruction: `Anda adalah seorang copywriter media sosial yang pakar dalam niche produk viral.
Gunakan nada santai, mesra, dan engaging. Bahasa pasar yang mudah difahami.

Berdasarkan produk "{{product.name}}":

[IMAGE_PROMPT]
Generate a high-quality product photography prompt in English. The image should showcase the product beautifully with professional lighting, clean background, and appealing composition. Include lifestyle elements that match the product category.

[VIDEO_PROMPT]
Generate a cinematic motion video prompt in English. Create smooth camera movements (pan, zoom, orbit) around the product. Add subtle particle effects, ambient lighting transitions, and premium feel. 5 seconds duration.

[CAPTION]
Tulis caption TikTok dalam Bahasa Malaysia yang santai & engaging. Guna emoji, hashtag trending, dan CTA yang natural. Maksimum 150 patah perkataan.`
                },
                {
                    id: 'set2', targetSet: 'set2', label: 'Set 2 (Yakin)',
                    instruction: `Anda adalah pakar produk yang meyakinkan dan profesional.
Gunakan fakta, kelebihan, dan kredibiliti produk. Nada yakin tetapi mesra.

Berdasarkan produk "{{product.name}}":

[IMAGE_PROMPT]
Generate a premium product showcase prompt in English. Emphasize product details, texture, and quality. Use dramatic lighting with dark/moody background. Show the product from an angle that highlights its best features.

[VIDEO_PROMPT]
Generate a professional product reveal video prompt in English. Start with a dramatic close-up, slowly pull back to reveal the full product. Add cinematic lighting shifts and subtle depth-of-field effects. 5 seconds duration.

[CAPTION]
Tulis caption TikTok dalam Bahasa Malaysia yang meyakinkan. Fokus pada kelebihan & keunikan produk. Gunakan testimoni style dan social proof. Maksimum 150 patah perkataan.`
                },
                {
                    id: 'set3', targetSet: 'set3', label: 'Set 3 (Urgent)',
                    instruction: `Anda adalah pakar pemasaran yang mencipta urgency dan FOMO.
Gunakan teknik scarcity, limited time offer, dan CTA yang kuat.

Berdasarkan produk "{{product.name}}":

[IMAGE_PROMPT]
Generate an eye-catching promotional product image prompt in English. Use bold, vibrant colors. Add visual elements that create urgency - like sale badges, limited edition feel, or exclusive packaging showcase.

[VIDEO_PROMPT]
Generate a fast-paced, energetic product video prompt in English. Quick cuts, zoom effects, flash transitions. Dynamic text overlay feel. Create excitement and urgency. 5 seconds duration.

[CAPTION]
Tulis caption TikTok dalam Bahasa Malaysia yang urgent & FOMO. Pendek, padat, power. Tekankan "limited time", "stok terhad", "jangan lepas". Guna CTA kuat. Maksimum 100 patah perkataan.`
                }
            ],
            isAutoApply: false,
            isTurboMode: false
        };

        const currentSpace = spaces.find(s => s.id === selectedSpaceId);
        const isSystemSpace = currentSpace?.isSystem;
        const personasRef = isSystemSpace
            ? collection(db, 'system_spaces', 'ai8saat', 'personas')
            : collection(db, 'users', auth.currentUser.uid, 'personas');
        try {
            const docRef = doc(personasRef);
            await setDoc(docRef, newPersona);
            setActivePersonaId(docRef.id);
            console.log('[AIInstructions] Created persona at:', docRef.path);
        } catch (err) {
            console.error("Failed to create persona:", err);
        }
    };

    const isSystemPersona = localPersona?._isSystem && !isAdmin;


    return (
        <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">

            {/* Main Content */}
            <main className="flex-1 flex flex-col min-w-0 overflow-y-auto">

                {/* Header */}
                <header className="h-16 border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 flex items-center justify-between px-6 z-10 sticky top-0 backdrop-blur-md flex-shrink-0">
                    <div className="flex items-center gap-4">
                        <BrainCircuit className="text-indigo-600" />
                        <h2 className="font-bold text-slate-800 dark:text-slate-100">Logic Options Manager</h2>
                        {isSaving && <span className="text-xs text-slate-400 animate-pulse">Saving...</span>}
                    </div>
                    {/* Role Badge */}
                    <div className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${isAdmin
                        ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400'
                        : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'
                        }`}>
                        {isAdmin ? <ShieldCheck className="w-3.5 h-3.5" /> : <Lock className="w-3 h-3" />}
                        {isAdmin ? 'Admin Mode' : 'View Only'}
                    </div>
                </header>

                <div className="p-8 max-w-6xl mx-auto w-full space-y-8 pb-32">

                    {/* STEP 1: SELECT OR CREATE LOGIC OPTION */}
                    <section>
                        <div className="flex items-center justify-between mb-4">
                            <div className="flex items-center gap-2">
                                <span className="w-6 h-6 bg-indigo-600 text-white rounded-full flex items-center justify-center text-[10px] font-bold tracking-tight">1</span>
                                <h3 className="text-xs font-bold text-slate-400 uppercase tracking-widest">Select or Create Logic Option</h3>
                            </div>

                        </div>

                        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
                            {/* New Logic Button — ADMIN ONLY */}
                            {isAdmin ? (
                                <button
                                    onClick={handleCreatePersona}
                                    className="min-w-[240px] p-4 border-2 border-dashed border-indigo-400/50 hover:border-indigo-500 bg-indigo-50/50 dark:bg-indigo-500/5 rounded-xl flex flex-col items-center justify-center gap-3 transition-all group shrink-0"
                                >
                                    <div className="w-10 h-10 rounded-full bg-white dark:bg-indigo-500/20 text-indigo-500 flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform">
                                        <Plus className="w-5 h-5" />
                                    </div>
                                    <span className="text-xs font-bold text-indigo-600 dark:text-indigo-400 uppercase tracking-widest">New Logic Option</span>
                                </button>
                            ) : (
                                /* CLIENT: Locked "New Logic" indicator */
                                <div className="min-w-[240px] p-4 border-2 border-dashed border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/30 rounded-xl flex flex-col items-center justify-center gap-3 shrink-0 opacity-50 cursor-not-allowed">
                                    <div className="w-10 h-10 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-400 flex items-center justify-center">
                                        <Lock className="w-4 h-4" />
                                    </div>
                                    <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">Admin Sahaja</span>
                                </div>
                            )}

                            {allPersonas.map(persona => (
                                <div
                                    key={persona.id}
                                    onClick={() => setActivePersonaId(persona.id)}
                                    className={`min-w-[240px] p-4 border-2 rounded-xl cursor-pointer relative shrink-0 transition-all ${activePersonaId === persona.id
                                        ? 'border-indigo-600 bg-indigo-600/5 shadow-md shadow-indigo-600/10'
                                        : 'border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 hover:border-slate-300 dark:hover:border-slate-700'
                                        }`}
                                >
                                    <div className="flex items-center justify-between mb-2">
                                        <div className="flex items-center gap-2">
                                            <span className={`text-xs font-semibold ${activePersonaId === persona.id ? 'text-indigo-600' : 'dark:text-white'}`}>
                                                {persona.name}
                                            </span>
                                            {persona._isSystem && (
                                                <span className="text-[8px] font-black uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-gradient-to-r from-amber-100 to-orange-100 dark:from-amber-900/30 dark:to-orange-900/30 text-amber-700 dark:text-amber-400 border border-amber-200/60 dark:border-amber-700/40">
                                                    System Default
                                                </span>
                                            )}
                                        </div>
                                        {activePersonaId === persona.id && <CheckCircle className="w-4 h-4 text-indigo-600" />}
                                    </div>
                                    <p className="text-xs text-slate-500 line-clamp-2">{persona.description}</p>
                                </div>
                            ))}
                            {allPersonas.length === 0 && (
                                <div className="text-sm text-slate-400 italic p-4 border border-dashed border-slate-300 rounded-xl w-full text-center">
                                    No logic options found. {isAdmin ? 'Create your first one to get started!' : 'Contact admin to setup AI Logic.'}
                                </div>
                            )}
                        </div>
                    </section>

                    {/* STEP 2: CONFIGURE SYSTEM INSTRUCTIONS */}
                    {localPersona && (
                        <section>
                            <div className="flex items-center justify-between mb-4">
                                <div className="flex items-center gap-2">
                                    <span className="w-6 h-6 bg-indigo-600 text-white rounded-full flex items-center justify-center text-[10px] font-bold tracking-tight">2</span>
                                    <h3 className="text-xs font-bold text-slate-400 uppercase tracking-widest">
                                        {isSystemPersona ? 'View System Instructions' : 'Configure System Instructions'}
                                    </h3>
                                    {isSystemPersona && (
                                        <span className="text-[9px] font-bold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 px-2 py-0.5 rounded-full border border-amber-200/60 dark:border-amber-700/40 flex items-center gap-1">
                                            <Lock className="w-2.5 h-2.5" />
                                            Read Only
                                        </span>
                                    )}
                                </div>
                                {/* Action buttons — admin only */}
                                {isAdmin && !localPersona._isSystem && (
                                    <div className="flex items-center gap-2">
                                        <button
                                            onClick={() => {
                                                const currentSets = localPersona.sets
                                                    ? [...localPersona.sets]
                                                    : (localPersona.instruction ? [{ id: 'set1', label: 'Legacy Set', instruction: localPersona.instruction, targetSet: 'set1' }] : []);

                                                const nextId = `set${Date.now()}`;
                                                currentSets.push({ id: nextId, targetSet: 'set1', label: 'New Set', instruction: '' });
                                                handleLocalUpdate({ sets: currentSets });
                                            }}
                                            className="text-indigo-600 hover:text-indigo-500 transition-colors flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider bg-indigo-50 hover:bg-indigo-100 dark:bg-indigo-900/20 dark:hover:bg-indigo-900/40 px-3 py-1.5 rounded-lg"
                                        >
                                            <Plus className="w-3.5 h-3.5" />
                                            Add Set
                                        </button>
                                        <button
                                            onClick={handleDeletePersona}
                                            className="text-rose-500 hover:text-rose-600 transition-colors flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider bg-rose-50 hover:bg-rose-100 dark:bg-rose-900/20 dark:hover:bg-rose-900/40 px-3 py-1.5 rounded-lg"
                                        >
                                            <Trash2 className="w-3.5 h-3.5" />
                                            Delete Logic
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className="space-y-6">
                                {/* Logic Meta */}
                                <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 shadow-sm">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Logic Option Name</label>
                                            <input
                                                type="text"
                                                value={localPersona.name}
                                                onChange={(e) => handleLocalUpdate({ name: e.target.value })}
                                                className={`w-full bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg p-3 text-sm focus:ring-indigo-500 focus:border-indigo-500 dark:text-white outline-none font-medium ${isSystemPersona ? 'opacity-60 cursor-not-allowed' : ''}`}
                                                placeholder="e.g., Teknik AI8SAAT"
                                                readOnly={isSystemPersona}
                                            />
                                        </div>
                                        <div className="flex items-end">
                                            <button
                                                onClick={() => !isSystemPersona && handleLocalUpdate({ jsonMode: !localPersona.jsonMode })}
                                                disabled={isSystemPersona}
                                                className={`flex items-center gap-2.5 px-4 py-3 rounded-lg border-2 transition-all text-sm font-bold ${isSystemPersona ? 'opacity-50 cursor-not-allowed' : ''} ${localPersona.jsonMode
                                                    ? 'border-amber-500 bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 shadow-md shadow-amber-500/10'
                                                    : 'border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-500 hover:border-slate-300'
                                                    }`}
                                            >
                                                <FileCode className="w-4 h-4" />
                                                <span>JSON Mode</span>
                                                <span className={`text-[9px] px-1.5 py-0.5 rounded-full font-bold uppercase tracking-wider ${localPersona.jsonMode
                                                    ? 'bg-amber-500 text-white'
                                                    : 'bg-slate-200 dark:bg-slate-700 text-slate-400'
                                                    }`}>
                                                    {localPersona.jsonMode ? 'ON' : 'OFF'}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    {localPersona.jsonMode && (
                                        <div className="mt-3 p-3 bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-800/50 rounded-lg">
                                            <p className="text-[10px] text-amber-700 dark:text-amber-400 font-medium">
                                                ⚡ JSON Mode: 1 instruction → 1 API call → output JSON lengkap dengan 3 set + product analysis. Lebih cepat dan structured.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* JSON MODE: Combined Instruction */}
                                {localPersona.jsonMode ? (
                                    <div className="bg-white dark:bg-slate-900 border-2 border-amber-300 dark:border-amber-700 rounded-2xl p-6 shadow-sm">
                                        <div className="flex items-center gap-3 mb-4">
                                            <span className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold bg-amber-100 text-amber-700">
                                                <FileCode className="w-4 h-4" />
                                            </span>
                                            <div>
                                                <h4 className="text-sm font-bold text-slate-700 dark:text-slate-200">Combined Instruction (JSON Mode)</h4>
                                                <p className="text-[10px] text-slate-400">1 instruction → 3 content sets + product analysis</p>
                                            </div>
                                        </div>
                                        <div className={`border border-amber-200 dark:border-amber-800/50 rounded-xl overflow-hidden transition-all ${isSystemPersona ? '' : 'focus-within:ring-2 focus-within:ring-amber-500/20'}`}>
                                            <div className="bg-amber-50 dark:bg-amber-900/20 px-4 py-2 border-b border-amber-200 dark:border-amber-800/50 flex items-center justify-between">
                                                <div className="flex items-center gap-2">
                                                    <span className="text-[10px] bg-amber-200 dark:bg-amber-800 text-amber-700 dark:text-amber-300 px-1.5 py-0.5 rounded font-mono uppercase tracking-tight">Master Instruction</span>
                                                    {isSystemPersona && (
                                                        <span className="text-[9px] text-amber-600 dark:text-amber-400 flex items-center gap-0.5">
                                                            <Lock className="w-2.5 h-2.5" /> by {systemDefaultLogicName}
                                                        </span>
                                                    )}
                                                </div>
                                                <span className="text-[9px] text-amber-500 font-mono">Output: JSON with 3 sets</span>
                                            </div>
                                            {/* Blurred container for system persona */}
                                            <div className="relative">
                                                <textarea
                                                    rows={16}
                                                    value={localPersona.combinedInstruction != null ? localPersona.combinedInstruction : (localPersona.sets && localPersona.sets[0]?.instruction) || ''}
                                                    onChange={(e) => handleLocalUpdate({ combinedInstruction: e.target.value })}
                                                    className={`w-full border-none bg-transparent focus:ring-0 text-sm leading-relaxed p-4 dark:text-slate-300 font-mono resize-none ${isSystemPersona ? 'select-none pointer-events-none' : 'resize-y'}`}
                                                    style={isSystemPersona ? { filter: 'blur(5px)', WebkitFilter: 'blur(5px)', userSelect: 'none' } : {}}
                                                    placeholder="Paste your comprehensive instruction here. This single instruction will generate all 3 content sets with product analysis in JSON format..."
                                                    readOnly={isSystemPersona}
                                                    tabIndex={isSystemPersona ? -1 : 0}
                                                />
                                                {isSystemPersona && (
                                                    <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-b from-white/60 via-white/30 to-white/70 dark:from-slate-900/60 dark:via-slate-900/30 dark:to-slate-900/70 rounded-b-xl" style={{ backdropFilter: 'blur(2px)' }}>
                                                        <div className="bg-white/90 dark:bg-slate-800/90 backdrop-blur-xl rounded-2xl px-8 py-5 shadow-xl shadow-amber-500/10 border border-amber-200/60 dark:border-amber-700/40 flex flex-col items-center gap-3">
                                                            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-100 to-orange-100 dark:from-amber-900/40 dark:to-orange-900/40 flex items-center justify-center">
                                                                <Lock className="w-5 h-5 text-amber-600 dark:text-amber-400" />
                                                            </div>
                                                            <div className="text-center">
                                                                <p className="text-sm font-bold text-slate-800 dark:text-slate-200">Kandungan Dilindungi</p>
                                                                <p className="text-[10px] text-slate-500 dark:text-slate-400 mt-1 max-w-[200px]">Master instruction ini dikawal oleh <strong className="text-amber-600">{systemDefaultLogicName}</strong> dan tidak boleh dilihat.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    /* LEGACY MODE: Per-set instruction boxes */
                                    <div className="grid grid-cols-1 gap-6">
                                        {(localPersona.sets || (localPersona.instruction ? [{ id: 'legacy', label: 'Legacy Set', instruction: localPersona.instruction, targetSet: 'set1' }] : [])).map((set, index) => (
                                            <div key={set.id} className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 shadow-sm relative group">
                                                <div className="flex items-center justify-between mb-4">
                                                    <div className="flex items-center gap-3">
                                                        <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold ${index === 0 ? 'bg-indigo-100 text-indigo-700' : index === 1 ? 'bg-purple-100 text-purple-700' : 'bg-emerald-100 text-emerald-700'}`}>
                                                            {index + 1}
                                                        </span>
                                                        <input
                                                            type="text"
                                                            value={set.label}
                                                            onChange={(e) => {
                                                                if (isSystemPersona) return;
                                                                const currentSets = localPersona.sets
                                                                    ? [...localPersona.sets]
                                                                    : (localPersona.instruction ? [{ id: 'legacy', label: 'Legacy Set', instruction: localPersona.instruction, targetSet: 'set1' }] : []);
                                                                if (currentSets[index]) {
                                                                    currentSets[index].label = e.target.value;
                                                                    handleLocalUpdate({ sets: currentSets });
                                                                }
                                                            }}
                                                            className={`bg-transparent border-none text-sm font-bold text-slate-700 dark:text-slate-200 focus:ring-0 p-0 hover:bg-slate-50 dark:hover:bg-slate-800/50 rounded px-2 -ml-2 transition-colors min-w-[150px] ${isSystemPersona ? 'cursor-not-allowed' : ''}`}
                                                            readOnly={isSystemPersona}
                                                        />
                                                        <div className="flex items-center gap-2 bg-slate-100 dark:bg-slate-800 rounded-lg px-2 py-1 ml-2">
                                                            <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">Target:</span>
                                                            <select
                                                                value={set.targetSet || (['set1', 'set2', 'set3'].includes(set.id) ? set.id : 'set1')}
                                                                onClick={(e) => e.stopPropagation()}
                                                                onChange={(e) => {
                                                                    if (isSystemPersona) return;
                                                                    const currentSets = localPersona.sets
                                                                        ? [...localPersona.sets]
                                                                        : (localPersona.instruction ? [{ id: 'legacy', label: 'Legacy Set', instruction: localPersona.instruction, targetSet: 'set1' }] : []);
                                                                    if (currentSets[index]) {
                                                                        currentSets[index].targetSet = e.target.value;
                                                                        handleLocalUpdate({ sets: currentSets });
                                                                    }
                                                                }}
                                                                disabled={isSystemPersona}
                                                                className={`bg-transparent border-none text-xs font-bold text-indigo-600 dark:text-indigo-400 outline-none cursor-pointer uppercase tracking-wider p-0 ${isSystemPersona ? 'opacity-60 cursor-not-allowed' : ''}`}
                                                            >
                                                                <option value="set1">Set 1</option>
                                                                <option value="set2">Set 2</option>
                                                                <option value="set3">Set 3</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {isAdmin && !localPersona._isSystem && (
                                                        <button
                                                            onClick={() => {
                                                                if (window.confirm("Delete this set box?")) {
                                                                    const currentSets = localPersona.sets
                                                                        ? [...localPersona.sets]
                                                                        : (localPersona.instruction ? [{ id: 'legacy', label: 'Legacy Set', instruction: localPersona.instruction }] : []);
                                                                    const newSets = currentSets.filter((_, i) => i !== index);
                                                                    handleLocalUpdate({ sets: newSets });
                                                                }
                                                            }}
                                                            className="opacity-0 group-hover:opacity-100 p-2 text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 rounded-lg transition-all"
                                                            title="Delete Set Box"
                                                        >
                                                            <Trash2 className="w-4 h-4" />
                                                        </button>
                                                    )}
                                                </div>
                                                <div className={`border border-slate-200 dark:border-slate-800 rounded-xl overflow-hidden transition-all ${isSystemPersona ? '' : 'focus-within:ring-2 focus-within:ring-indigo-600/20'}`}>
                                                    <div className="bg-slate-50 dark:bg-slate-800 px-4 py-2 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between">
                                                        <div className="flex items-center gap-2">
                                                            <span className="text-[10px] bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-300 px-1.5 py-0.5 rounded font-mono uppercase tracking-tight">System Prompt</span>
                                                            {isSystemPersona && (
                                                                <span className="text-[9px] text-slate-400 flex items-center gap-0.5">
                                                                    <Lock className="w-2.5 h-2.5" /> Dilindungi
                                                                </span>
                                                            )}
                                                        </div>
                                                        {!isSystemPersona && (
                                                            <div className="flex flex-col items-end gap-1">
                                                                <span className="text-[9px] text-slate-400 font-mono">Use &#123;&#123;product&#125;&#125; variables</span>
                                                                <div className="flex gap-2">
                                                                    <span className="text-[8px] bg-indigo-50 text-indigo-600 px-1 rounded border border-indigo-100 font-mono">[IMAGE_PROMPT]</span>
                                                                    <span className="text-[8px] bg-indigo-50 text-indigo-600 px-1 rounded border border-indigo-100 font-mono">[VIDEO_PROMPT]</span>
                                                                    <span className="text-[8px] bg-indigo-50 text-indigo-600 px-1 rounded border border-indigo-100 font-mono">[CAPTION]</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {/* Blurred container for system persona */}
                                                    <div className="relative">
                                                        <textarea
                                                            rows={6}
                                                            value={set.instruction}
                                                            onChange={(e) => {
                                                                if (isSystemPersona) return;
                                                                const currentSets = localPersona.sets
                                                                    ? [...localPersona.sets]
                                                                    : (localPersona.instruction ? [{ id: 'legacy', label: 'Legacy Set', instruction: localPersona.instruction }] : []);
                                                                if (currentSets[index]) {
                                                                    currentSets[index].instruction = e.target.value;
                                                                    handleLocalUpdate({ sets: currentSets });
                                                                }
                                                            }}
                                                            className={`w-full border-none bg-transparent focus:ring-0 text-sm leading-relaxed p-4 dark:text-slate-300 font-mono ${isSystemPersona ? 'select-none pointer-events-none resize-none' : 'resize-y'}`}
                                                            style={isSystemPersona ? { filter: 'blur(5px)', WebkitFilter: 'blur(5px)', userSelect: 'none' } : {}}
                                                            placeholder={`Enter instructions for ${set.label}...`}
                                                            readOnly={isSystemPersona}
                                                            tabIndex={isSystemPersona ? -1 : 0}
                                                        />
                                                        {isSystemPersona && (
                                                            <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-b from-white/60 via-white/30 to-white/70 dark:from-slate-900/60 dark:via-slate-900/30 dark:to-slate-900/70 rounded-b-xl" style={{ backdropFilter: 'blur(2px)' }}>
                                                                <div className="bg-white/90 dark:bg-slate-800/90 backdrop-blur-xl rounded-2xl px-6 py-4 shadow-xl shadow-indigo-500/10 border border-slate-200/60 dark:border-slate-700/40 flex flex-col items-center gap-2">
                                                                    <Lock className="w-4 h-4 text-slate-500 dark:text-slate-400" />
                                                                    <p className="text-[10px] font-bold text-slate-600 dark:text-slate-300">Kandungan Dilindungi</p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* AYAT WAJIB (Auto-Append to Image Prompt) */}
                                <div className="bg-white dark:bg-slate-900 border-2 border-blue-300 dark:border-blue-700 rounded-2xl p-6 shadow-sm">
                                    <div className="flex items-center gap-3 mb-4">
                                        <span className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold bg-blue-100 text-blue-700">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
                                        </span>
                                        <div>
                                            <h4 className="text-sm font-bold text-slate-700 dark:text-slate-200">Ayat Wajib — Auto Append (Image Prompt)</h4>
                                            <p className="text-[10px] text-slate-400">Teks ini akan ditambah secara automatik ke hujung setiap Image Prompt selepas AI generate. Sesuai untuk arahan visual yang wajib ada.</p>
                                        </div>
                                    </div>
                                    <div className={`border border-blue-200 dark:border-blue-800/50 rounded-xl overflow-hidden transition-all ${isSystemPersona ? '' : 'focus-within:ring-2 focus-within:ring-blue-500/20'}`}>
                                        <div className="bg-blue-50 dark:bg-blue-900/20 px-4 py-2 border-b border-blue-200 dark:border-blue-800/50 flex items-center justify-between">
                                            <span className="text-[10px] bg-blue-200 dark:bg-blue-800 text-blue-700 dark:text-blue-300 px-1.5 py-0.5 rounded font-mono uppercase tracking-tight">Mandatory Append</span>
                                            <span className="text-[9px] text-blue-500 font-mono">→ promptImage</span>
                                        </div>
                                        <div className="relative">
                                            <textarea
                                                rows={6}
                                                value={localPersona.mandatoryImageAppend || ''}
                                                onChange={(e) => handleLocalUpdate({ mandatoryImageAppend: e.target.value })}
                                                className={`w-full border-none bg-transparent focus:ring-0 text-sm leading-relaxed p-4 dark:text-slate-300 font-mono ${isSystemPersona ? 'select-none pointer-events-none resize-none' : 'resize-y'}`}
                                                style={isSystemPersona ? { filter: 'blur(5px)', WebkitFilter: 'blur(5px)', userSelect: 'none' } : {}}
                                                placeholder="Contoh: IMPORTANT: Do NOT modify the product. Retain all original details, design, colors, labels exactly as shown..."
                                                readOnly={isSystemPersona}
                                                tabIndex={isSystemPersona ? -1 : 0}
                                            />
                                            {isSystemPersona && (
                                                <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-b from-white/60 via-white/30 to-white/70 dark:from-slate-900/60 dark:via-slate-900/30 dark:to-slate-900/70 rounded-b-xl" style={{ backdropFilter: 'blur(2px)' }}>
                                                    <div className="bg-white/90 dark:bg-slate-800/90 backdrop-blur-xl rounded-2xl px-8 py-5 shadow-xl shadow-blue-500/10 border border-blue-200/60 dark:border-blue-700/40 flex flex-col items-center gap-3">
                                                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 dark:from-blue-900/40 dark:to-blue-800/40 flex items-center justify-center">
                                                            <Lock className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                                                        </div>
                                                        <div className="text-center">
                                                            <p className="text-sm font-bold text-slate-800 dark:text-slate-200">Kandungan Dilindungi</p>
                                                            <p className="text-[10px] text-slate-500 dark:text-slate-400 mt-1 max-w-[200px]">Ayat wajib image ini dikawal oleh <strong className="text-blue-600">{systemDefaultLogicName}</strong> dan tidak boleh dilihat.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* AYAT WAJIB (Auto-Append to Video Prompt) */}
                                <div className="bg-white dark:bg-slate-900 border-2 border-emerald-300 dark:border-emerald-700 rounded-2xl p-6 shadow-sm">
                                    <div className="flex items-center gap-3 mb-4">
                                        <span className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold bg-emerald-100 text-emerald-700">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                                        </span>
                                        <div>
                                            <h4 className="text-sm font-bold text-slate-700 dark:text-slate-200">Ayat Wajib — Auto Append (Video Prompt)</h4>
                                            <p className="text-[10px] text-slate-400">Teks ini akan ditambah secara automatik ke hujung setiap Video Prompt selepas AI generate. Sesuai untuk arahan teknikal yang wajib ada.</p>
                                        </div>
                                    </div>
                                    <div className={`border border-emerald-200 dark:border-emerald-800/50 rounded-xl overflow-hidden transition-all ${isSystemPersona ? '' : 'focus-within:ring-2 focus-within:ring-emerald-500/20'}`}>
                                        <div className="bg-emerald-50 dark:bg-emerald-900/20 px-4 py-2 border-b border-emerald-200 dark:border-emerald-800/50 flex items-center justify-between">
                                            <span className="text-[10px] bg-emerald-200 dark:bg-emerald-800 text-emerald-700 dark:text-emerald-300 px-1.5 py-0.5 rounded font-mono uppercase tracking-tight">Mandatory Append</span>
                                            <span className="text-[9px] text-emerald-500 font-mono">→ promptVideo</span>
                                        </div>
                                        <div className="relative">
                                            <textarea
                                                rows={6}
                                                value={localPersona.mandatoryVideoAppend || ''}
                                                onChange={(e) => handleLocalUpdate({ mandatoryVideoAppend: e.target.value })}
                                                className={`w-full border-none bg-transparent focus:ring-0 text-sm leading-relaxed p-4 dark:text-slate-300 font-mono ${isSystemPersona ? 'select-none pointer-events-none resize-none' : 'resize-y'}`}
                                                style={isSystemPersona ? { filter: 'blur(5px)', WebkitFilter: 'blur(5px)', userSelect: 'none' } : {}}
                                                placeholder="Contoh: Fast-paced, high-energy voice delivery. Confident TikTok-style selling tone. NO subtitles or text overlays..."
                                                readOnly={isSystemPersona}
                                                tabIndex={isSystemPersona ? -1 : 0}
                                            />
                                            {isSystemPersona && (
                                                <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-b from-white/60 via-white/30 to-white/70 dark:from-slate-900/60 dark:via-slate-900/30 dark:to-slate-900/70 rounded-b-xl" style={{ backdropFilter: 'blur(2px)' }}>
                                                    <div className="bg-white/90 dark:bg-slate-800/90 backdrop-blur-xl rounded-2xl px-8 py-5 shadow-xl shadow-emerald-500/10 border border-emerald-200/60 dark:border-emerald-700/40 flex flex-col items-center gap-3">
                                                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-emerald-100 to-emerald-200 dark:from-emerald-900/40 dark:to-emerald-800/40 flex items-center justify-center">
                                                            <Lock className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
                                                        </div>
                                                        <div className="text-center">
                                                            <p className="text-sm font-bold text-slate-800 dark:text-slate-200">Kandungan Dilindungi</p>
                                                            <p className="text-[10px] text-slate-500 dark:text-slate-400 mt-1 max-w-[200px]">Ayat wajib video ini dikawal oleh <strong className="text-emerald-600">{systemDefaultLogicName}</strong> dan tidak boleh dilihat.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}

                    {/* SAVE BUTTON & NOTIFICATION — only for admin or own (non-system) personas */}
                    {localPersona && !isSystemPersona && (
                        <div className="mt-8 pb-32 flex flex-col items-center justify-center space-y-4">
                            {showSaveNotification && (
                                <div className="flex items-center gap-2 px-4 py-2 bg-emerald-500 text-white rounded-full shadow-lg animate-in fade-in slide-in-from-bottom-2 duration-300">
                                    <CheckCircle className="w-5 h-5" />
                                    <span className="text-xs font-bold uppercase tracking-wide">Configuration Saved Successfully!</span>
                                </div>
                            )}

                            <button
                                onClick={handleSaveChanges}
                                disabled={isSaving}
                                className="group relative px-8 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-bold shadow-xl shadow-indigo-600/20 disabled:opacity-50 disabled:cursor-not-allowed transition-all active:scale-95 flex items-center gap-3"
                            >
                                {isSaving ? (
                                    <>
                                        <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                                        <span>Saving...</span>
                                    </>
                                ) : (
                                    <>
                                        <Save className="w-5 h-5 group-hover:scale-110 transition-transform" />
                                        <span>Save Configuration</span>
                                    </>
                                )}
                            </button>
                            <p className="text-[10px] text-slate-400">Remember to save your changes before leaving.</p>
                        </div>
                    )}

                    {/* READ-ONLY NOTICE for system persona */}
                    {localPersona && isSystemPersona && (
                        <div className="mt-8 pb-32 flex flex-col items-center justify-center space-y-3">
                            <div className="flex items-center gap-2 px-5 py-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/50 rounded-xl">
                                <Lock className="w-4 h-4 text-amber-500" />
                                <p className="text-xs font-medium text-amber-700 dark:text-amber-400">
                                    Ini adalah <strong>{systemDefaultLogicName}</strong> — logic default oleh system. Hanya admin boleh mengubah konfigurasi ini.
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default AIInstructionsView;
